type Name='back'|'user'|'account'|'gift'|'refresh'|'calendar'|'calendar-x'|'football'|'check'|'cross'|'clock';
export default function CouponIcon({name}:{name:Name}){
 const shapes:Record<Name,React.ReactNode>={
  back:<path d="m12 5-7 7 7 7M5 12h15"/>,
  user:<><circle cx="12" cy="12" r="9"/><circle cx="12" cy="9" r="2.5"/><path d="M6.5 18c.5-4.5 10.5-4.5 11 0"/></>,
  account:<><path d="M10 4H4v16h6m4-12 4 4-4 4m-6-4h10"/></>,
  gift:<><path d="M3 8h18v5H3zM5 13v8h14v-8M12 8v13"/><path d="M12 8H8a3 3 0 1 1 3-3l1 3Zm0 0h4a3 3 0 1 0-3-3l-1 3Z"/></>,
  refresh:<><path d="M20 4v6h-6M4 20v-6h6"/><path d="M5.5 8A7.5 7.5 0 0 1 18 5l2 5M4 14l2 5a7.5 7.5 0 0 0 12.5-3"/></>,
  calendar:<><rect x="4" y="5" width="16" height="16" rx="2"/><path d="M8 3v4m8-4v4M4 10h16"/></>,
  'calendar-x':<><rect x="4" y="5" width="16" height="16" rx="2"/><path d="M8 3v4m8-4v4M4 10h16m-11 4 6 4m0-4-6 4"/></>,
  football:<><circle cx="12" cy="12" r="9"/><path d="m12 7 5 4-2 5H9l-2-5 5-4Zm0 0V3m5 8 4-1m-6 6 2 4m-8-4-2 4m0-9-4-1"/></>,
  check:<path d="m5 12 4 4L19 6"/>,cross:<><circle cx="12" cy="12" r="9"/><path d="m9 9 6 6m0-6-6 6"/></>,
  clock:<><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></>,
 };
 return <svg className={'coupon-icon coupon-icon-'+name} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">{shapes[name]}</svg>;
}
